import React from 'react';
import { Typography } from '@mui/material/';

const SearchSuggestions = ({
    suggestions,
    selectedIndex,
    onSuggestionClick,
    stockDataMap
}) => {
    const [hoveredIndex, setHoveredIndex] = React.useState(-1);

    const getStockIcon = (symbol) => {
        if (stockDataMap && stockDataMap.has(symbol)) {
            const stockData = stockDataMap.get(symbol);
            if (stockData.logo_url) {
                return (
                    <img
                        src={stockData.logo_url}
                        alt={symbol}
                        className="w-11 h-11 rounded-full object-contain"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.textContent = 'img';
                        }}
                    />
                );
            }
        }
        return 'img';
    };

    if (!suggestions || suggestions.length === 0) return null;

    return (
        <div
            className="suggestions-container absolute top-full left-0 mt-2 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200"
            style={{
                width: '400px',
                zIndex: 9999
            }}
        >
            <div className="max-h-500px overflow-y-auto">
                {suggestions.map((stock, index) => {
                    const isSelected = index === selectedIndex;
                    const isHovered = index === hoveredIndex;
                    const isActive = isSelected || isHovered;

                    return (
                        <button
                            key={stock.symbol}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                onSuggestionClick(stock.symbol);
                            }}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(-1)}
                            className={`suggestion-item w-full px-5 py-4 transition-all duration-150 flex items-center gap-4 border-b border-gray-100 last-border-b-0 ${isActive
                                ? 'bg-blue-100 border-l-4 border-l-blue-500'
                                : 'hover-bg-gray-50 border-l-4 border-l-transparent'
                                }`}
                        >
                            <div className="stock-icon-container w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                                {getStockIcon(stock.symbol)}
                            </div>

                            <div className="stock-info flex-1 text-left min-w-0">
                                <div className="stock-symbol font-semibold text-gray-900 text-base">
                                    {/* {stock.symbol} */}
                                    <Typography variant="body1" gutterBottom>
                                        {stock.symbol}
                                    </Typography>
                                </div>
                                <div className="stock-description text-sm text-gray-500 truncate mt-0.5">
                                    {/* {stock.description || stock.name} */}
                                    <Typography variant="body1" gutterBottom>
                                        {stock.description || stock.name}
                                    </Typography>
                                </div>
                            </div>

                            <div className="stock-exchange-container flex items-center gap-2 flex-shrink-0">
                                <span className="stock-exchange text-sm font-medium text-gray-600">
                                    {/* {stock.exchange} */}
                                    <Typography variant="body1" gutterBottom>
                                        {stock.exchange}
                                    </Typography>
                                </span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default SearchSuggestions;